import React from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { BoardIcon, EyeIcon, ListViewIcon } from 'components/SVG';
import { usePopover } from 'hooks/common';

type Props = { onClick: (type: 'list' | 'canvas') => void };

function BoardViewMenu({ onClick }: Props) {
  const { anchorEl, openPopover, closePopover } = usePopover();

  return (
    <>
      <IconButton onClick={openPopover} size='small'>
        <EyeIcon width='25' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ top: '5px' }}
      >
        <MenuItem
          onClick={() => {
            onClick('canvas');
            closePopover();
          }}
        >
          <BoardIcon color='black' />
          <Typography sx={{ marginLeft: 1 }} component='span' variant='body1'>
            Board
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClick('list');
            closePopover();
          }}
        >
          <ListViewIcon />
          <Typography sx={{ marginLeft: 1 }} component='span' variant='body1'>
            List
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

export default BoardViewMenu;
